module.exports = __webpack_public_path__ + "static/media/autopay_example.dad42cee.png";